import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-panel-footer',
  styleUrls: ['./panel-footer.component.scss'],
  templateUrl: './panel-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class PanelFooterComponent {}
